import Bugsnag from '@bugsnag/js'

// Check if we are in a production runtime environment
const isProdRuntime =
  process.env.NEXT_PHASE !== 'phase-production-build' && process.env.NODE_ENV === 'production'

export const start = async () => {
  if (isProdRuntime && process.env.BUGSNAG_API_KEY) {
    const plugins = []

    // Conditionally include AWS Lambda plugin on the server
    if (process.env.NEXT_IS_SERVER === 'true') {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      plugins.push(require('@bugsnag/plugin-aws-lambda'))
    }

    /**
     * We only load Bugsnag on the full Next environment. Next only runs middleware
     * in the edge runtime so we can't use bugsnag since `navigator` is not defined
     * in the edge runtime.
     */
    if (process.env.NEXT_RUNTIME !== 'edge') {
      Bugsnag.start({
        apiKey: process.env.BUGSNAG_API_KEY,
        appVersion: process.env.BUILDSTAMP,
        releaseStage: process.env.APP_ENV,
        plugins,
      })
    }
  }
}

/**
 * Returns the Bugsnag plugin for use with AWS Lambda functions.
 */
export const getServerlessHandler = () => Bugsnag.getPlugin('awsLambda')?.createHandler()
